<template>
	<div>
		<b-row>
			<b-col md="6" class="my-1">
				<h3 class="text-themecolor">{{$t('carpetline.overdegebruiker')}}</h3>
			</b-col>
		</b-row>
		<b-row>
			<b-col md="12">
				<div class="card">
					<div class="card-body">
						<div v-if="usercustomerrelation && usercustomerrelation.id">
                            <!-- customerRelationId -->
							<small class="text-muted">{{$t('datatables.klantrelatie')}}</small>
							<h6 v-if="usercustomerrelation.customerRelation">{{usercustomerrelation.customerRelation.tag}} - {{usercustomerrelation.customerRelation.name}}</h6>
                            <!-- fullName -->
							<small class="text-muted">{{$t('datatables.naam')}}</small>
							<h6 v-if="usercustomerrelation.user">{{usercustomerrelation.user.fullName}}</h6>
							<h6 v-else>{{$t('error.onbekend')}}</h6>
                            <!-- emailAddress -->
							<small class="text-muted">{{$t('datatables.emailadres')}}</small>
							<h6 v-if="usercustomerrelation.user.emailAddress">{{usercustomerrelation.user.emailAddress.address}}</h6>
							<h6 v-else>{{$t('error.onbekend')}}</h6>
						</div>
						<div v-else>
							<content-placeholders>
								<content-placeholders-heading />
								<content-placeholders-text :lines="2" />
							</content-placeholders>
						</div>
					</div>
				</div>
			</b-col>
		</b-row>
		<b-row>
			<b-col md="12">
				<b-button @click="goTo('index')" variant="secondary">{{$t('buttons.terugnaaroverzicht')}}</b-button>
			</b-col>
		</b-row>
	</div>
</template>

<script>
//Import store
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'user-detail',
    computed: {
        ...mapGetters('carpetline',['usercustomerrelation'])
    },
    methods: {
        ...mapActions('carpetline',['find']),
        goTo(name) {
            var vm = this;
            vm.$router.push({ name: `user-customer-relations:${name}` });
        }
    },
    created() {
        var vm = this;
        // vm.$route.params.orderId;
        vm.find({
            resource: 'user-customer-relations',
            id: this.$route.params.userId
        });
    }
}

</script>